import { Box, LinearProgress, Typography } from '@mui/material';
import { colors } from 'Constants/Colors';
import GenericTableText from './GenericTableText/GenericTableText';

interface ProgressIndicatorProps {
  completed: number;
  total: number;
  emptyMessage?: string;
}

const ProgressIndicator = ({ completed, total, emptyMessage = 'Nothing to evaluate' }: ProgressIndicatorProps) => {
  const progress = (completed / total) * 100;

  // Si no hay nada para evaluar, mostrar un mensaje en tooltip
  if (total === 0 && completed === 0) {
    return <GenericTableText text={emptyMessage} />;
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
        {`${completed} / ${total}`}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 1,
          backgroundColor: `${colors.GREEN}20`,
          '& .MuiLinearProgress-bar': {
            backgroundColor: colors.GREEN,
          },
        }}
      />
    </Box>
  );
};

export default ProgressIndicator;
